import { render, staticRenderFns } from "./MobileBottomBar.vue?vue&type=template&id=6243c83d&scoped=true&"
import script from "./MobileBottomBar.vue?vue&type=script&lang=js&"
export * from "./MobileBottomBar.vue?vue&type=script&lang=js&"
import style0 from "./MobileBottomBar.vue?vue&type=style&index=0&id=6243c83d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6243c83d",
  null
  
)

export default component.exports